// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Yodt","productName":"Table_productName__1N7Zm"};